<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}"></ngx-loading>
<div class="wrapper">
    <app-sidebar></app-sidebar>
    <app-header></app-header>
    <div class="page-wrapper">
        <div class="page-content">
            <!--breadcrumb-->
            <div class="page-breadcrumb d-sm-flex align-items-center mb-4">
                <!-- <div class="breadcrumb-title pe-3"><span [translate]="'GREATER.REFERAL'"> </span></div> -->
                <div class="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0 p-0">
                            <li class="breadcrumb-item"><a href="javascript:void(0);" routerLink="/dashboard" ><i class="bx bx-home-alt"></i></a>
                            </li>
                            <!-- <li class="breadcrumb-item active" aria-current="page"><span [translate]="'GREATER.REFERAL'"> </span></li> -->
                        </ol>
                    </nav>
                </div>
                <div class="ms-auto">
                    <div class="btn-group">
                        <!-- <button type="button" class="btn brandpurpal-btn split-bg-primary dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown">	<span>Toggle Dropdown</span>
                        </button>
                        <div class="dropdown-menu dropdown-menu-right dropdown-menu-lg-end"> <a class="dropdown-item" href="javascript:void(0)"><span [translate]="'GREATER.LOW'"> </span></a>
                            <a class="dropdown-item" href="javascript:void(0)">Another action</a>
                            <a class="dropdown-item" href="javascript:void(0)">Something else here</a>
                            <div class="dropdown-divider"></div> <a class="dropdown-item" href="javascript:void(0)">Separated link</a>
                        </div> -->
                    </div>
                </div>
            </div>
            <!--end breadcrumb-->

            <div class="row">
               
                <!-- <div class="col-2 pb-3" *ngIf="dataListing.length > 0">
                    <label for="inputState" class="form-label"><span [translate]="'GREATER.LIMIT'"> </span></label>
                    <select id="inputState" class="form-select" [(ngModel)]='pageLimit' (change)="p=1;p=1;getDetail(p)">
                    <option *ngFor="let item of service.LimitArray">{{item}}</option>
                    </select>                   
                </div> -->
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="card-title d-flex align-items-center">
                                <h5 class="mb-2" ><span [translate]="'GREATER.REFERAL'"> </span></h5>
                            </div>
                            <hr>
                            <table class="table mb-0 table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col"><span [translate]="'GREATER.NO'"> </span>.</th>
                                        <th scope="col"><span [translate]="'GREATER.REFERRED_BY'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.REFERRED_TO'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.EMAIL'"> </span></th>
                                        <!-- <th scope="col"><span [translate]="'GREATER.REASON'"> </span></th> -->
                                        <th scope="col"><span [translate]="'GREATER.REFERRAL_CODE'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.REFERRAL'"> </span></th>
                                        <th scope="col" class="d-flex"><span [translate]="'GREATER.DATE'"></span> 
                                           <span style="cursor: pointer;" class="ms-2"> <i class="bx bx-arrow-to-top" (click)="sortType='asc';p=1;getDetail(p)"></i> <i class="bx bx-arrow-to-bottom" (click)="sortType='desc';p=1;getDetail(p)"></i></span>  </th>
                                        <th scope="col"><span [translate]="'GREATER.STATUS'"> </span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of DataListing | paginate: { itemsPerPage: pageLimit, currentPage: p, totalItems: totalCount}; let i = index ">
                                        <td scope="row">{{(pageLimit * (p - 1)) + i + 1 }}</td>                                        
                                        <td>{{item.user_info.name}} {{item.user_info.surname}}</td>
                                        <td>{{item.name}} {{item.surname}}</td>
                                        <td>{{item.email}}</td>
                                        <td>{{item.user_info.referral_code}}</td>
                                        <td>
                                            <div>
                                                <span class="badge bg-success" *ngIf="item.referral_apply ==true"><span [translate]="'GREATER.USED'"> </span></span>
                                                <span class="badge bg-info" *ngIf="item.referral_apply == false"><span [translate]="'GREATER.NOT_USED'"> </span></span>
                                            </div>
                                        </td>
                                       <td>{{service.convertDate(item.createdAt)}} </td>
                                        <td>
                                            <div>
                                                <span class="badge bg-success" *ngIf="item.status =='Active' ">{{item.status}}</span>
                                                <!-- <span class="badge bg-primary" *ngIf="item.status == 'Unpublished'">{{item.status}}</span>
                                                <span class="badge bg-danger" *ngIf="item.status == 'Denied'">{{item.status}}</span> -->
                                                <span class="badge bg-info" *ngIf="item.status == 'Pending'">{{item.status}}</span>
                                            </div>
                                        </td>
                                       
                                    </tr>

                                </tbody>
                            </table>
                            <div class="pagination-block pt-5">
                                <pagination-controls [previousLabel]="previousLabel" [nextLabel]="nextLabel" (pageChange)="getDetail((p = $event))" class="text-center" *ngIf="DataListing.length > 0"></pagination-controls>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--end row-->





        </div>
    </div>
    <app-footer></app-footer>
</div>